// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ms-modal-container{max-height:80vh}.ms-modal{-webkit-transition:opacity .15s ease;transition:opacity .15s ease;z-index:999999}.ms-modal-active{overflow-x:hidden;overflow-y:visible!important}", ""]);
// Exports
module.exports = exports;
